module.exports = __webpack_public_path__ + "img/ico-posts.291bd8a8.svg";